<template>
  <carousel-component
    v-if="renderedSlides.length"
    :min-item-width="300"
    :item-data="renderedSlides"
    :displayed-quantity="1"
    :autoscroll-delay="10000"
    :scrolled-quantity="1"
    :max-per-line="renderedSlides.length"
    :show-arrow="false"
    class="main-banner"
    need-infinity
    show-dots
  >
    <template v-slot:default="{ props: slide }">
      <slide-item
        :key="slide.id"
        :content-position="slide.content_position"
        :text-color="slide.text_color"
        :background-color="slide.background_color"
        :opacity="slide.opacity"
        :text-align="slide.text_align"
        :video="slide.video"
        :image="slide.image"
        :main-title="slide.main_title"
        :second-title="slide.second_title"
        :btn-title="slide.btn_title"
        :link="slide.link"
        :btn-color="slide.btn_color"
        :btn-text-color="slide.btn_text_color"
        />
    </template>
  </carousel-component>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {SLIDES_TYPES, URL_QUERIES} from '@/const';
import {GET_CHANNEL_SLIDES_FOR_QUERY} from '@/store/getterTypes';
import CarouselComponent from '@/components/base-components/CarouselComponent.vue';

import SlideItem from './SlideItem.vue';

export default {
  name: 'SliderComponent',
  components: {
    CarouselComponent,
    SlideItem,
  },
  data() {
    return {
      categoryQuery: this.$route.query?.[URL_QUERIES.category]?.toLowerCase(),
      participantGroupQuery: this.$route.query?.[URL_QUERIES.participantGroup]?.toLowerCase(),
      participantQuery: this.$route.query?.[URL_QUERIES.PARTICIPANT]?.toLowerCase(),
    };
  },
  computed: {
    ...mapState({
      slides: (state) => state.channel.slides,
    }),
    ...mapGetters({
      slidesGetter: GET_CHANNEL_SLIDES_FOR_QUERY,
    }),
    renderedSlides() {
      let selectedSlides;
      if (this.categoryQuery) {
        selectedSlides = this.slidesGetter(SLIDES_TYPES.category, this.categoryQuery);
      }
      if (this.participantGroupQuery) {
        selectedSlides = this.slidesGetter(SLIDES_TYPES.group, this.participantGroupQuery);
      }
      if (this.participantQuery) {
        selectedSlides = this.slidesGetter(SLIDES_TYPES.participant, this.participantQuery);
      }
      return selectedSlides || this.slides[SLIDES_TYPES.main];
    },
  },
  watch: {
    $route(to) {
      this.categoryQuery = to.query?.[URL_QUERIES.category]?.toLowerCase?.();
      this.participantGroupQuery = to.query?.[URL_QUERIES.participantGroup]?.toLowerCase?.();
      this.participantQuery = to.query?.[URL_QUERIES.PARTICIPANT]?.toLowerCase?.();
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/css/mixins";

.main-banner {
  margin-top: 4.375rem;
  max-width: 100vw;
}
@include media-max(md) {
  .main-banner{
    margin-top: 3rem;
  }
}
</style>
